module.exports = __webpack_public_path__ + "static/img/zhengshu.313a8b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhengshu.png
// module id = brWm
// module chunks = 1